import hrApi from '@/api/v1/hr';
import { mapSelectedFeaturesArrayToSearchFiltersObject } from '@/helpers/utils';
import assign from 'lodash/assign';

export default {
  namespaced: true,

  state: {
    developers: [],
    features: [],
    selectedFeatures: [],
    totals: 0,
    pagination: {
      page: 1,
      itemsPerPage: 20,
      mustSort: false,
      multiSort: true,
      sortBy: [],
      sortDesc: [],
    },
    isDataLoading: false,
  },

  mutations: {
    CHANGE_DEVELOPERS(state, developers) {
      state.developers = developers;
    },

    CHANGE_PAGINATION(state, pagination) {
      state.pagination = assign(state.pagination, pagination);
    },

    CHANGE_TOTALS_NUMBER(state, totals) {
      state.totals = totals;
    },

    CHANGE_FEATURES(state, features) {
      state.features = features;
    },

    CHANGE_LOADING_STATUS(state, status) {
      state.isDataLoading = status;
    },

    CHANGE_SELECTED_FEATURES(state, featuresList) {
      state.selectedFeatures = featuresList;
    },
  },

  actions: {
    fetchDevelopers({ state, commit }) {
      commit('CHANGE_LOADING_STATUS', true);

      const fetchParams = {
        ...state.pagination,
        filters: mapSelectedFeaturesArrayToSearchFiltersObject(state.selectedFeatures),
      };

      return new Promise((resolve, reject) => {
        hrApi.developers
          .index(fetchParams)
          .then((resp) => {
            commit('CHANGE_TOTALS_NUMBER', resp.data.pagination.itemsLength);
            commit('CHANGE_PAGINATION', resp.data.pagination);
            commit('CHANGE_DEVELOPERS', resp.data.collection);
            resolve();
          })
          .catch(() => {
            reject();
          })
          .finally(() => {
            commit('CHANGE_LOADING_STATUS', false);
          });
      });
    },

    fetchFeatures({ commit }) {
      hrApi.features
        .index()
        .then((resp) => {
          commit('CHANGE_FEATURES', resp.data);
        })
        .catch(() => {
        });
    },

    deleteDeveloper({ commit, dispatch }, id) {
      commit('CHANGE_LOADING_STATUS', true);

      return new Promise((resolve, reject) => {
        hrApi.developers
          .delete(id)
          .then((resp) => {
            dispatch('fetchDevelopers');
            resolve(resp);
          })
          .catch((err) => {
            dispatch('showError', err.response.data.errors, { root: true });
            reject();
          })
          .finally(() => {
            commit('CHANGE_LOADING_STATUS', false);
          });
      });
    },

    setPagination({ commit }, pagination) {
      commit('CHANGE_PAGINATION', pagination);
    },

    setSelectedFeatures({ commit }, featuresList) {
      commit('CHANGE_PAGINATION', { page: 1 });
      commit('CHANGE_SELECTED_FEATURES', featuresList);
    },
  },
};
